import { ThemeProvider } from '@mui/material';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import { AdminAuthProvider } from './Context/AdminAuthContext';
import { AuthContextProvider } from './Context/AuthContext';
import { InsuranceCalculatorProvider } from './Context/Calculator/InsuranceCalculatorContext';
import LoaderProvider from './Context/LoadingContext';
import { SnackbarProvider } from './Context/SnackbarContext';
import { TrackingContextProvider } from './Context/TrackingContext';
import AdminLayout from './pages/admin/AdminLayout';
import AdminLogin from './pages/admin/AdminLogin';
import AdminTotpSetup from './pages/admin/AdminTotpSetup';
import AdminTotpVerify from './pages/admin/AdminTotpVerify';
import AdminBrokers from './pages/admin/Brokers';
import AdminCustomers from './pages/admin/Customers';
import AdminGroups from './pages/admin/Groups';
import AdminQuizResults from './pages/admin/QuizResults';
import BaseCalculator from './components/BaseCalculator/BaseCalculator';
import Address from './pages/Address';
import Banking from './pages/Banking';
import Base from './pages/Base';
import Compliance from './pages/Compliance';
import Home from './pages/Home';
import Login from './pages/Login';
import PolicyDetails from './pages/PolicyDetails/PolicyDetails';
import Register from './pages/Register';
import TermsAndConditions from './pages/TermsAndConditions';
import { getTheme } from './utils/themeLoader';
import { StepProvider } from './Context/StepContext';
import Navigator from './pages/Navigator';
import PaymentMethod from './pages/PaymentMethod';
import CWallet from './pages/CWallet';

function App() {

  const theme = getTheme();
  return (
    <>
    <StepProvider>
      <AdminAuthProvider>
      <ThemeProvider theme={theme} >
        <SnackbarProvider>
          <LoaderProvider>
            <TrackingContextProvider>
              <AuthContextProvider>
                  <InsuranceCalculatorProvider>
                    <Routes>
                      <Route path="/" element={<Base />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/base" element={<BaseCalculator />} />
                      </Route>

                      <Route path="/customer" element={<Navigator />}>
                        <Route path="register" element={<Register />} />
                        <Route path="address" element={<Address />} />
                        <Route path="compliance" element={<Compliance />} />
                        <Route path="policy" element={<PolicyDetails />} />
                        <Route path="banking" element={<Banking />} />
                        <Route path="paymentmethod" element={<PaymentMethod />} />
                        <Route path="wallet" element={<CWallet />} />
                        <Route path="sign" element={<TermsAndConditions />} />
                      </Route>

                      {/* ── Admin portal ──────────────────────────────── */}
                      <Route path="/admin/login"    element={<AdminLogin />} />
                      <Route path="/admin/2fa/setup"  element={<AdminTotpSetup />} />
                      <Route path="/admin/2fa/verify" element={<AdminTotpVerify />} />
                      <Route path="/admin" element={<AdminLayout />}>
                        <Route index          element={<AdminBrokers />} />
                        <Route path="brokers"     element={<AdminBrokers />} />
                        <Route path="customers"   element={<AdminCustomers />} />
                        <Route path="quiz-results" element={<AdminQuizResults />} />
                        <Route path="groups"      element={<AdminGroups />} />
                      </Route>
                    </Routes>
                  </InsuranceCalculatorProvider>
              </AuthContextProvider >
            </TrackingContextProvider>
          </LoaderProvider>
        </SnackbarProvider>
      </ThemeProvider>
      </AdminAuthProvider>
      </StepProvider>
    </>
  )
}

export default App


